import {Layout} from 'antd';
import React from 'react';

import {BrowserView, MobileView} from '../../libs/ui/src';

import {Header} from '../';
import Navigation from '../navigation/navigation';
import MobileNavigation from '../navigation/mobileNavigation';

export const PageWrapper = ({children, pageName}: any) => (
  <Layout style={{height: '100%'}} className={`page-${pageName}`}>
    <Header />
    <Layout style={{position: 'relative'}} hasSider>
      <div style={{borderRight: '1px solid var(--color-light-gray)'}}>
        <BrowserView>
          <Navigation />
        </BrowserView>
        <MobileView>
          <MobileNavigation />
        </MobileView>
      </div>
      <Layout.Content>{children}</Layout.Content>
    </Layout>
  </Layout>
);
